import { Connection, LAMPORTS_PER_SOL, PublicKey } from "@solana/web3.js";
import { useSolanaWallets } from "@privy-io/react-auth";
import { useEffect, useState } from "react";

export const rpcUrl = import.meta.env.PROD
  ? import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_PRODUCTION
  : import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_DEVELOPMENT;

export function useSolanaBalance() {
  const { wallets } = useSolanaWallets();
  const solWallet = wallets?.[0];
  const [balance, setBalance] = useState<number | null>(null);

  const getBalance = async () => {
    if (!solWallet?.address) return;

    try {
      const connection = new Connection(rpcUrl);
      const publicKey = new PublicKey(solWallet.address);
      const balance = await connection.getBalance(publicKey);
      setBalance(balance / LAMPORTS_PER_SOL);
    } catch (error) {
      console.error("Error fetching Solana balance:", error);
    }
  };

  useEffect(() => {
    getBalance();
  }, [solWallet?.address]);

  return balance;
}
